import React, { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";

import ProfileService from "../../services/ProfileService";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";

const BalanceSection = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [earningDetails, setEarningDetails] = useState();

  useEffect(() => {
    fetchData();
    fetchEarningDetails();
  }, []);

  const fetchData = async () => {
    setLoading(true);

    try {
      const result = await ProfileService.fetchBalance();

      if (!result.success) {
        Swal.fire("Opps!", result.message, "error");
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        var data = responseData.data;
        setData(data);
      } else {
        Swal.fire("Opps!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Opps!",
        "Request Failed:",
        error.response?.data || error.message,
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchEarningDetails = async () => {
    setLoading(true);

    try {
      const result = await ProfileService.fetchEarningDetails();

      if (!result.success) {
        Swal.fire("Opps!", result.message, "error");
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        var data = responseData.data;
        setEarningDetails(data);
      } else {
        Swal.fire("Opps!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Opps!",
        "Request Failed:",
        error.response?.data || error.message,
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      {data && (
        <div className="row mb-3">
          <div className="col-md-4">
            <div className="card border-primary shadow-sm">
              <div className="card-body text-center text-primary">
                <h6>Available Balance</h6>
                <h4>₹{data.main_wallet}</h4>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-success shadow-sm">
              <div className="card-body text-center text-success">
                <h6>Cashback Today</h6>
                <h4>₹{earningDetails ? earningDetails.today_earning : "0"}</h4>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-dark shadow-sm">
              <div className="card-body text-center text-dark">
                <h6>Lifetime Cashback</h6>
                <h4>
                  ₹{earningDetails ? earningDetails.lifetime_earning : "0"}
                </h4>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default BalanceSection;
